import React, { Component } from 'react';
import { translate } from 'react-i18next';
import swal from 'sweetalert';

var Config = require('../../../config');

class STData extends Component{
	constructor(props, context) {
		super(props, context);

		this.state = {
			balanzas:[]
		}
	}

	//Consulta de servicios necesarios para la pantalla
	componentDidMount() {
		this.props.onRef(this);
		
		fetch(Config.default.apiGateway.URL+'equipments/actives?type=BALANZA',{
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({balanzas: response});
			}
		});
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	//Contenido del Formulario
	render(){
		const { t } = this.props;
		return(
			<div style={{padding:"0px"}}>
			{!this.props.state.hideFieldsAph ? 
				<div style={{padding:"0px"}}>
					<div className="col-xs-12" style={{padding:"0px"}}>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">{t('content.extractions.st.duration')}</span>
							<input type="number" step="0.01" className="form-control volume-unit" name="extraction_time" id="extraction_time" 
								value={ this.props.state.extraction_time || ""} onChange={ this.props.handleChange } required
								disabled={!this.props.state.can_be_edit || this.props.state.disabled_element} onKeyPress={(e) => this.props.validate(e)}/>
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">{t('content.extractions.st.volume')}</span>
							<input className="form-control volume-unit" required name="volume" id="volume" 
								value={ this.props.state.volume || "" } onChange={ this.props.handleChange } type="number"
								disabled={!this.props.state.can_be_edit || this.props.state.disabled_element} onKeyPress={(e) => this.props.validate(e)}/>
						</div>
						<div className="col-xs-12 col-sm-4">
							<span className="span-min">Balanza</span>
							<select className="form-control" name="equipment_st_id" id="equipment_st_id" value={this.props.state.equipment_st_id}
								onChange={this.props.handleChange} disabled={!this.props.state.can_be_edit || this.props.state.disabled_element} onKeyPress={(e) => this.props.validate(e)}
							>
								<option value="">Seleccione...</option>
								{this.state.balanzas.map((b, i)=>
									<option key={i} value={b.equipment.id}>
										{b.equipment.name}
									</option>
								)}
							</select>
						</div>
						
					</div>
					<div className="col-xs-12" style={{padding:0}}>
						<div className="col-xs-12 col-sm-2">
				        	<span className="span-min">{t('content.extractions.st.lote_number')}</span>
							<input className="form-control" name="lote_number" id="lote_number" 
								value={ this.props.state.lote_number || "" } onChange={ this.props.handleChange }
								disabled={this.props.state.disabled_element} onKeyPress={(e) => this.props.validate(e)}/>
						</div>
					</div>
		        </div>
		        :null
		    }
		    </div>
		);
	}
}

export default translate('translations')(STData);